import React, { useEffect, useState } from "react";
import "../../newComponents/MainDashboard/mainDashboard.css";
import "./tasklist.css";
import {
  Modal,
  Input,
  Button,
  DatePicker,
  Space,
  Select,
  Menu,
  Dropdown,
  Icon
} from "antd";
import { useTheme } from "../../utils/ThemeContext";
import filterIcon from "../../assets/images/debtPayoff/filter.png";
import moment from "moment";
import DASHBOARD_API from "../../apis/dashboard.api";
import NewLoader from "../styled-components/loader/NewLoader";
import SpinLoader from "../styled-components/loader/SpinLoader";
import DEATH_API from "../../apis/death.api";
import swal from "sweetalert";
const { Option, OptGroup } = Select;

const { RangePicker } = DatePicker;

function TasksList() {
  const { theme } = useTheme();
  const googleAccessToken = localStorage.getItem("googleAccessToken");
  const googleRefreshToken = localStorage.getItem("googleRefreshToken");

  const [tasks, setTasks] = useState();
  const [alltasks, setAllTasks] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [viewModal,setViewModal]=useState(false);
  const [selectedTask,setSelectedTask] =useState(null);
  const [loading, setLoading] = useState(false);
  const [isReady, setReady] = useState(false);
  const [formData,setFormData]=useState(null);
  const [isTaskUpdate, setIsTaskUpdate] = useState(false);
  const [seletedFilter, setSeletedFilter] = useState(null);
  const [createdAt, setCreatedAt] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const filteredTasks =
    tasks &&
    tasks.filter((task) =>
      task.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const getTaskList = async () => {
    if (googleAccessToken && googleRefreshToken) {
      try {
        setLoading(true);
        const response = await DASHBOARD_API.fetchTasks();
        console.log("tasks listing==>", response);

        if (response && response.data) {
          setTasks(response.data);
          setAllTasks(response.data);
          if(seletedFilter && seletedFilter){
            handleApplyFilterChange(response.data,seletedFilter);
          }
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("error while getting task list==>", error);
      }
    }
  };

  useEffect(() => {
    getTaskList();
  }, []);

  const toggleSelect = async (id, status) => {
    const newStatus = status === "completed" ? "needsAction" : "completed";
    const updatedTasks = tasks.map((task) =>
      task.id === id ? { ...task, status: newStatus } : task
    );
    setTasks(updatedTasks);
    try {
      let payload = { status: newStatus,completed: new Date().toISOString() };
      setLoading(true);
      const res = await DASHBOARD_API.updateTaskStatus(id, payload);
      if(res && res.statusCode === 200){
        swal("Success","Task Status Updated","success");
        await getTaskList();
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to update task status:", error);
      setLoading(false);
      const revertedTasks = tasks.map((task) =>
        task.id === id ? { ...task, status } : task
      );
      setTasks(revertedTasks);
    }
  };
  const handleTaskClick=(task)=>{
    setIsTaskUpdate(true);
    handleViewModalOpen();
    let taskToUpdate = {
      title: task && task.title,
      notes: task && task.notes,
      due: task && task.due,
      status:task && task.status,
      id: task && task.id,
    };
    setSelectedTask(taskToUpdate);
  }

  const handleEditItem=(task)=>{
    setViewModal(false);
    handleOpenModal();
    setFormData(selectedTask && selectedTask);
  }
  const deleteGoogleTask = async (task) => {
    setViewModal(false);
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this ?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          const taskId = task && task.id;
          let res = await DASHBOARD_API.deleteGoogleTask(
            taskId,
          );
          if (res && res.statusCode === 200) {
            swal("Deleted!", "Your Event has been deleted.", "success");
            await getTaskList();
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log("error while deleting Event", error);
        }
      }
    });
    setSelectedTask(null);
  };

  const handleAddTask = async () => {
    try {
      setLoading(true);
      setIsModalVisible(false);
      setCreatedAt(null);
      let payload = {
        title: formData && formData.title,
        notes: formData && formData.notes,
        due: formData && formData.due ? moment.utc(formData.due).format("YYYY-MM-DDTHH:mm:ssZ") : "",
      };
      let res = await DASHBOARD_API.createTask(payload);

      if (res) {
        console.log("Google task created successfully==>", res);
        await getTaskList();
      }
    } catch (error) {
      setLoading(false);
      console.log("error while trying to create google task==>", error);
    }
    setFormData(null);
  };
  const handleUpdateTask = async () => {
    try {
      setLoading(true);
      setIsModalVisible(false);
      let payload = {
        title: formData && formData.title,
        notes: formData && formData.notes,
        due: formData && formData.due ? moment.utc(formData.due).format("YYYY-MM-DDTHH:mm:ssZ") : "",
        status:formData && formData.status,
      };
      let res = await DASHBOARD_API.updateTaskStatus(formData.id, payload);

      if (res && res.statusCode===200) {
        console.log("Google task Updated successfully==>", res);
        swal("Success",res.message,"success");
        await getTaskList();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while trying to create google task==>", error);
    }
    setSelectedTask(null);
    setFormData(null);
  };

  const formatDate = (date) => {
    return moment(date).format("ddd, MMM DD");
  };

  const calculateDaysUntilEnd = (endDate) => {
    const today = moment().startOf("day");
    const end = moment(endDate).endOf("day");
    const daysUntilEnd = end.diff(today, "days");
    return daysUntilEnd;
  };

  const handleInputChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleEndDateChange = (date, dateString) => {
    if (dateString) {
      setEndDate(date);
    }
  };

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };
  const handleViewModalOpen = () => {
    setViewModal(true);
  };
  const handleViewModalCancel = () => {
    setViewModal(false);
    setSelectedTask(null);
    setFormData(null);
  };

  const handleCancelModal = () => {
    setIsModalVisible(false);
    setIsTaskUpdate(false);
    setFormData(null);

  };
  const handleGoogleLogin = async () => {
    try {
      setReady(true);
      const response = await DEATH_API.googleAuthLogin();
      if (response) {
        setReady(false);
        window.open(response.googleAuthUrl, "_self");
      }
    } catch (error) {
      setReady(false);
      console.log("error while logging in", error);
    }
  };
  // const handleApplyFilter = (filter) => {
  //   const now = new Date();
  //   let filtered = [];
  //   console.log("tasks",tasks)
  //   switch (filter) {
  //     case "Today":
  //       filtered = alltasks && alltasks.filter(task =>
  //         new Date(task.due).toDateString() === now.toDateString()
  //       );
  //       console.log("filter",filter,filtered,alltasks)
  //       break;
  //     case "Tomorrow":
  //       const tomorrow = new Date();
  //       tomorrow.setDate(tomorrow.getDate() + 1);
  //       filtered = alltasks && alltasks.filter(task =>
  //         new Date(task.due).toDateString() === tomorrow.toDateString()
  //       );
  //       console.log("filter",filter,filtered,alltasks)
  //       break;
  //     case "Upcoming week":
  //       const nextWeek = new Date();
  //       nextWeek.setDate(now.getDate() + 7);
  //       filtered = alltasks && alltasks.filter(task =>
  //         new Date(task.due) > now && new Date(task.due) <= nextWeek
  //       );
  //       console.log("filter",filter,filtered,alltasks)
  //       break;
  //     case "No Due Date":
  //       filtered = alltasks && alltasks.filter(task => !task.due);
  //       console.log("filter",filter,filtered,alltasks)
  //       break;
  //     case "Everything":
  //       filtered = alltasks && alltasks; // Include all alltasks
  //       console.log("filter",filter,filtered,alltasks)
  //       break;
  //     case "Last Year":
  //       filtered = alltasks && alltasks.filter(task =>
  //         new Date(task.due).getFullYear() === now.getFullYear() - 1
  //       );
  //       console.log("filter",filter,filtered,alltasks)

  //       break;
  //     case "Completed Tasks":
  //       filtered = alltasks && alltasks.filter(task => task.status === "completed");
  //       console.log("filter",filter,filtered,alltasks)
  //       break;
  //     default:
  //       filtered = alltasks && alltasks;
  //   }

  //   setTasks(filtered);
  // };
  const handleApplyFilterChange = (tasks,filter) => {
    const now = new Date(); // Current date and time
    const todayUTC = new Date(
      Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
    ); // Today's date in UTC
    let filtered = [];

    switch (filter) {
      // case "Today":
      //   filtered =
      //     alltasks &&
      //     alltasks.filter((task) => {
      //       if (!task.due) return false; // Skip tasks without a due date
      //       const taskDate = new Date(task.due);
      //       return (
      //         !isNaN(taskDate) &&
      //         taskDate.toISOString().split("T")[0] ===
      //           todayUTC.toISOString().split("T")[0]
      //       );
      //     });
      //   break;

      // case "Tomorrow":
      //   const tomorrowUTC = new Date(
      //     Date.UTC(
      //       todayUTC.getFullYear(),
      //       todayUTC.getMonth(),
      //       todayUTC.getDate() + 1
      //     )
      //   ); // Tomorrow's date in UTC
      //   filtered =
      //     alltasks &&
      //     alltasks.filter((task) => {
      //       if (!task.due) return false; // Skip tasks without a due date
      //       const taskDate = new Date(task.due);
      //       return (
      //         !isNaN(taskDate) &&
      //         taskDate.toISOString().split("T")[0] ===
      //           tomorrowUTC.toISOString().split("T")[0]
      //       );
      //     });
      //   break;

      // case "Upcoming week":
      //   const nextWeekUTC = new Date(
      //     Date.UTC(
      //       todayUTC.getFullYear(),
      //       todayUTC.getMonth(),
      //       todayUTC.getDate() + 7
      //     )
      //   ); // One week from today in UTC
      //   filtered =
      //     alltasks &&
      //     alltasks.filter((task) => {
      //       if (!task.due) return false; // Skip tasks without a due date
      //       const taskDate = new Date(task.due);
      //       return (
      //         !isNaN(taskDate) && taskDate > todayUTC && taskDate <= nextWeekUTC
      //       );
      //     });
      //   break;

      case "Today":
        filtered =
          tasks &&
          tasks.filter((task) => {
            if (!task.due) return false; // Skip tasks without a due date
            const taskDate = new Date(task.due);
            const isToday =
              !isNaN(taskDate) &&
              taskDate.toISOString().split("T")[0] ===
                todayUTC.toISOString().split("T")[0];
            const isBeforeToday =
              !isNaN(taskDate) &&
              taskDate < todayUTC;
            const isIncomplete = task.status !== "completed";
            return ((isToday && isIncomplete) || (isBeforeToday && isIncomplete));
          });
        break;
  
      case "Tomorrow":
        const tomorrowUTC = new Date(
          Date.UTC(
            todayUTC.getFullYear(),
            todayUTC.getMonth(),
            todayUTC.getDate() + 1
          )
        ); // Tomorrow's date in UTC
        filtered =
          tasks &&
          tasks.filter((task) => {
            if (!task.due) return false; // Skip tasks without a due date
            const taskDate = new Date(task.due);
            const isToday =
              !isNaN(taskDate) &&
              taskDate.toISOString().split("T")[0] ===
                todayUTC.toISOString().split("T")[0];
            const isTomorrow =
              !isNaN(taskDate) &&
              taskDate.toISOString().split("T")[0] ===
                tomorrowUTC.toISOString().split("T")[0];
            const isIncomplete = task.status !== "completed";
            const isPastIncomplete = taskDate < todayUTC && isIncomplete; // Ensure incomplete for past tasks

            return (isToday && isIncomplete) || (isTomorrow && isIncomplete) || isPastIncomplete;
          });
        break;
  
        case "Upcoming week":
          const nextWeekUTC = new Date(
            Date.UTC(
              todayUTC.getFullYear(),
              todayUTC.getMonth(),
              todayUTC.getDate() + 7
            )
          ); // One week from today in UTC
          filtered =
            tasks &&
            tasks.filter((task) => {
              if (!task.due) return false; // Skip tasks without a due date
              const taskDate = new Date(task.due);
              const isInUpcomingWeek =
                !isNaN(taskDate) && taskDate >= todayUTC && taskDate <= nextWeekUTC;
              const isIncomplete = task.status !== "completed";
              const isPastIncomplete = taskDate < todayUTC && isIncomplete; // Ensure incomplete for past tasks

              return (isInUpcomingWeek && isIncomplete) || isPastIncomplete;
            });
          break;

      case "No Due Date":
        filtered =
          tasks &&
          tasks.filter(
            (task) => !task.due || isNaN(new Date(task.due).getTime())
          ); // Tasks without a valid due date
        break;

      case "Everything":
        filtered = tasks; // Include all tasks
        break;

      case "Last Year":
        const lastYear = todayUTC.getUTCFullYear() - 1;
        filtered =
          tasks &&
          tasks.filter((task) => {
            if (!task.due) return false; // Skip tasks without a due date
            const taskDate = new Date(task.due);
            return !isNaN(taskDate) && taskDate.getUTCFullYear() === lastYear;
          });
        break;

      case "Completed Tasks":
        filtered =
          tasks && tasks.filter((task) => task.status === "completed");
        break;

      default:
        filtered = tasks;
    }

    setTasks(filtered);
  };
  const handleApplyFilter = (filter) => {
    const now = new Date(); // Current date and time
    const todayUTC = new Date(
      Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
    ); // Today's date in UTC
    let filtered = [];

    switch (filter) {
      // case "Today":
      //   filtered =
      //     alltasks &&
      //     alltasks.filter((task) => {
      //       if (!task.due) return false; // Skip tasks without a due date
      //       const taskDate = new Date(task.due);
      //       return (
      //         !isNaN(taskDate) &&
      //         taskDate.toISOString().split("T")[0] ===
      //           todayUTC.toISOString().split("T")[0]
      //       );
      //     });
      //   break;

      // case "Tomorrow":
      //   const tomorrowUTC = new Date(
      //     Date.UTC(
      //       todayUTC.getFullYear(),
      //       todayUTC.getMonth(),
      //       todayUTC.getDate() + 1
      //     )
      //   ); // Tomorrow's date in UTC
      //   filtered =
      //     alltasks &&
      //     alltasks.filter((task) => {
      //       if (!task.due) return false; // Skip tasks without a due date
      //       const taskDate = new Date(task.due);
      //       return (
      //         !isNaN(taskDate) &&
      //         taskDate.toISOString().split("T")[0] ===
      //           tomorrowUTC.toISOString().split("T")[0]
      //       );
      //     });
      //   break;

      // case "Upcoming week":
      //   const nextWeekUTC = new Date(
      //     Date.UTC(
      //       todayUTC.getFullYear(),
      //       todayUTC.getMonth(),
      //       todayUTC.getDate() + 7
      //     )
      //   ); // One week from today in UTC
      //   filtered =
      //     alltasks &&
      //     alltasks.filter((task) => {
      //       if (!task.due) return false; // Skip tasks without a due date
      //       const taskDate = new Date(task.due);
      //       return (
      //         !isNaN(taskDate) && taskDate > todayUTC && taskDate <= nextWeekUTC
      //       );
      //     });
      //   break;

      case "Today":
        filtered =
          alltasks &&
          alltasks.filter((task) => {
            if (!task.due) return false; // Skip tasks without a due date
            const taskDate = new Date(task.due);
            const isToday =
              !isNaN(taskDate) &&
              taskDate.toISOString().split("T")[0] ===
                todayUTC.toISOString().split("T")[0];
            const isBeforeToday =
              !isNaN(taskDate) &&
              taskDate < todayUTC;
            const isIncomplete = task.status !== "completed";
            return ((isToday && isIncomplete) || (isBeforeToday && isIncomplete)); // Show today's tasks and incomplete tasks from before today
          });
        break;
  
      case "Tomorrow":
        const today=new Date();
        const tomorrowUTC = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate() + 1
        ); // Tomorrow's date in UTC
        filtered =
          alltasks &&
          alltasks.filter((task) => {
            if (!task.due) return false; // Skip tasks without a due date
            const taskDate = new Date(task.due);
            const isToday =
              !isNaN(taskDate) &&
              taskDate.toISOString().split("T")[0] ===
                todayUTC.toISOString().split("T")[0];
            const isTomorrow =
              !isNaN(taskDate) &&
              taskDate.toISOString().split("T")[0] ===
                tomorrowUTC.toISOString().split("T")[0];
            const isIncomplete = task.status !== "completed";
            const isPastIncomplete = taskDate < todayUTC && isIncomplete; // Ensure incomplete for past tasks

            return (isToday && isIncomplete) || (isTomorrow && isIncomplete) || isPastIncomplete;
          });
        break;
  
        case "Upcoming week":
          const nextWeekUTC = new Date(
            Date.UTC(
              todayUTC.getFullYear(),
              todayUTC.getMonth(),
              todayUTC.getDate() + 7
            )
          ); // One week from today in UTC
          filtered =
            alltasks &&
            alltasks.filter((task) => {
              if (!task.due) return false; // Skip tasks without a due date
              const taskDate = new Date(task.due);
              const isInUpcomingWeek =
                !isNaN(taskDate) && taskDate >= todayUTC && taskDate <= nextWeekUTC;
              const isIncomplete = task.status !== "completed";
              const isPastIncomplete = taskDate < todayUTC && isIncomplete; // Ensure incomplete for past tasks

              return (isInUpcomingWeek && isIncomplete) || isPastIncomplete; // Include only incomplete tasks
            });
          break;

      case "No Due Date":
        filtered =
          alltasks &&
          alltasks.filter(
            (task) => !task.due || isNaN(new Date(task.due).getTime())
          ); // Tasks without a valid due date
        break;

      case "Everything":
        filtered = alltasks; // Include all tasks
        break;

      case "Last Year":
        const lastYear = todayUTC.getUTCFullYear() - 1;
        filtered =
          alltasks &&
          alltasks.filter((task) => {
            if (!task.due) return false; // Skip tasks without a due date
            const taskDate = new Date(task.due);
            return !isNaN(taskDate) && taskDate.getUTCFullYear() === lastYear;
          });
        break;

      case "Completed Tasks":
        filtered =
          alltasks && alltasks.filter((task) => task.status === "completed");
        break;

      default:
        filtered = alltasks;
    }

    setTasks(filtered);
  };

  const tags = [
    "Today",
    "Tomorrow",
    "Upcoming week",
    "No Due Date",
    "Everything",
    "Completed Tasks",
  ];

  return (
    <div
      className="SavingMainCard2"
      style={{
        position: "relative",
        width: "100%",
        backgroundColor: theme === "dark" ? "#232323" : "white",
        padding: "1rem",
        borderRadius: "16px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
        }}
      >
        <h1
          className="SavingCardheading"
          style={{
            marginBottom: "8px",
            color: theme === "light" ? "#232323" : "white",
          }}
        >
          Tasks list
        </h1>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
        }}>
        {googleAccessToken &&
          <button
          className="google-login-button"
            onClick={() => {
              getTaskList();
            }}
          >
          Refresh
          </button>
          }
        <button
          className="google-login-button"
          onClick={() => {
            handleGoogleLogin();
          }}
        >
          {isReady ? (
            <SpinLoader isLoading={isReady} />
          ) : !googleAccessToken ? (
            "Login with Google"
          ) : (
            "Change Account"
          )}
        </button>
        </div>
      </div>
      <div className="search-add-container">
        <input
          style={{
            border: "1px solid #dedede",
            borderRadius: "6px",
            padding: "2px 10px",
          }}
          type="text"
          placeholder="Search tasks..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div className="filterIcons">
          <Select
            showSearch
            style={{ width: 200, outline: "none", border: "none" }}
            placeholder="Select Filter"
            onChange={(value, id) => {
              console.log("value", value);
              setSeletedFilter(value);
              handleApplyFilter(value);
            }}
          >
            {tags &&
              tags.map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
          </Select>
        </div>
       {/* <div className="filterIcons">
          <Dropdown
            trigger={["click"]}
            overlay={
              <Menu>
                <Menu.Item>
                  <div
                    onClick={() => {
                      // sortData("category");
                    }}
                  >
                    By Date
                  </div>
                </Menu.Item>
                <Menu.Item>
                  <div
                    onClick={() => {
                      // sortData("amountLowToHigh");
                    }}
                  >
                    By Priority
                  </div>
                </Menu.Item>
                <Menu.Item>
                  <div
                    onClick={() => {
                      // sortData("amountHighToLow");
                    }}
                  >
                    By Title
                  </div>
                </Menu.Item>
              </Menu>
            }
          >
            <a
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            >
              <img src={filterIcon} height={24} width={24} alt="icon"></img>
            </a>
          </Dropdown>{" "}
        </div> */}
      </div>
      <div className="task-list">
        <ul>
          {filteredTasks &&
            filteredTasks.map((task) => (
              <li
                key={task.id}
                className={task.status == "completed" ? "selected" : ""}
                style={{display:"flex", gap:"8px", flexDirection:"row"}}
                // onClick={() => toggleSelect(task.id, task.status)}
              >
                <div className="task-container" style={{width:"fit-content"}}>
                  <input
                    type="checkbox"
                    checked={task.status == "completed" ? true : false}
                    onChange={() => toggleSelect(task.id, task.status)}
                  />
                  </div>
                  <div style={{width:"100%"}}
                  onClick={()=>{
                    handleTaskClick(task)
                  }}>
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "13px",
                      fontWeight: "400",
                      lineHeight: "18px",
                      textAlign: "left",
                      color: theme === "light" ? "#232323" : "white",
                    }}
                   
                  >
                    {task.title}
                  </span>
                <div
                  style={{
                    color: theme === "light" ? "#232323" : "white",
                    paddingLeft:"0px",
                  }}
                  className="task-date"
                >
                  {formatDate(task.due)} ({calculateDaysUntilEnd(task.due)}
                  Days)
                </div>
                </div>
              </li>
            ))}
        </ul>
        <div
          className="add-task-container"
          style={{
            marginTop: "10px",
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <button
            className="taskListButtonAddTask"
            style={{
              opacity: googleAccessToken ? "1" : "0.5",
              cursor: googleAccessToken ? "pointer" : "not-allowed",
            }}
            onClick={handleOpenModal}
          >
            Add Task
          </button>
        </div>
      </div>
 {/* Event Details Modal */}
      <Modal
        visible={viewModal}
        onOk={handleViewModalCancel}
        onCancel={handleViewModalCancel}
        footer={null}
        closable={false}
        centered
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <h3 className="modaltitle">Task Details</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "1rem",
            }}
          >
            <Icon
              type="delete"
              style={{ cursor: "pointer", fontSize: "20px", color: "#2a3da3" }}
              onClick={() => {
                if (selectedTask) {
                  deleteGoogleTask(selectedTask);
                }
              }}
            />
            <Icon
              type="edit"
              style={{ cursor: "pointer", fontSize: "20px", color: "#2a3da3" }}
              onClick={() => {
                if (selectedTask) {
                  handleEditItem(selectedTask);
                }
              }}
            />
          </div>
        </div>
        {selectedTask ? (
          <div style={{ color: "#2a3da3" }}>
            <p>
              <strong>Title:</strong>{" "}
              {selectedTask.title ? selectedTask.title : "N/A"}
            </p>
            <p>
              <strong>Due Date:</strong>{" "}
              {selectedTask.due
                ? moment.utc(selectedTask.due).format("MM-DD-YYYY hh:mm a")
                : "N/A"}
            </p>
            <p>
              <strong>Status:</strong>{" "}
              {selectedTask.status
                ? (selectedTask.status)
                : "N/A"}
            </p>
            <p>
              <strong>Description:</strong>{" "}
              {selectedTask.notes ? selectedTask.notes : "N/A"}
            </p>
            {/* <p>
              <strong>Link:</strong>{" "}
              {selectedEvent.hangoutLink ? (
                <a href={selectedEvent.hangoutLink} target="_blank">
                  {selectedEvent.hangoutLink
                    ? selectedEvent.hangoutLink
                    : "N/A"}
                </a>
              ) : (
                "N/A"
              )}
            </p> */}
          </div>
        ) : (
          <h3 className="inputTitle">No Details Found</h3>
        )}
        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleViewModalCancel();
            }}
          >
            Close
          </button>
        </div>
      </Modal>
      <Modal
        visible={isModalVisible}
        onOk={handleAddTask}
        onCancel={handleCancelModal}
        footer={null}
        closable={false}
        centered
      >
      <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">{selectedTask ? "Update " : "Add "} Task</h3>
        </div>
        <div style={{ marginBottom: "10px" }}>
        <h3 className="inputTitle">Task Title</h3>
          <Input
            placeholder="Enter task title"
            value={formData && formData.title}
            name="title"
            onChange={(e) => {
                handleInputChange(e.target.name, e.target.value);
            }}
          />
        </div>
        <div style={{ marginBottom: "10px" }}>
        <h3 className="inputTitle">Description</h3>
          <Input
            placeholder="Enter description"
            value={formData && formData.notes}
            name="notes"
            onChange={(e) => {
              handleInputChange(e.target.name, e.target.value);
          }}
          />
        </div>
        {/* <div style={{ marginBottom: "10px" }}>
          <label style={{ marginBottom: "2px" }}>Created At</label>
          <div className="date-picker-outer">
            <DatePicker
              className="date-picker-input-container"
              showTime
              format="YYYY-MM-DD HH:mm"
              disabledDate={(current) => {
                let customDate = moment().format("YYYY-MM-DD");
                return current && current < moment(customDate, "YYYY-MM-DD");
              }}
              onChange={handleDateChange}
              value={createdAt}
            />
          </div>
        </div> */}

        <div style={{ marginBottom: "10px" }}>
        <h3 className="inputTitle">Due Date</h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              showTime={{ format: "hh:mm A" }}
              format={"MM/DD/YYYY  hh:mm A"}
              disabledDate={(current) => {
                let customDate = moment.utc().format("YYYY-MM-DD");
                return current && current < moment.utc(customDate, "YYYY-MM-DD");
              }}
              name="due"
              size="large"
              id="newDate"
              onChange={(date, dateString) => {
                handleInputChange("due", dateString);
              }}
              value={formData && formData.due && moment.utc(formData.due)}
            />
          </div>
        <div className="buttonsMain">
        <button
          className="cancelbutton"
          onClick={() => {
            handleCancelModal();
          }}
        >
          Cancel
        </button>
        <button
          className="savebutton"
          // disabled={!data || !data.asset}
          onClick={() => {
            if(selectedTask && selectedTask){
              handleUpdateTask();
            }else{
              handleAddTask();
            }
          }}
        >
          Save
        </button>
      </div>
      </Modal>
      <NewLoader isLoading={loading} />
    </div>
  );
}

export default TasksList;